var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_10613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4442_10613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.46422C0 2.62766 0.292801 1.9375 0.878378 1.39376C1.46396 0.849996 2.22523 0.578125 3.16216 0.578125C4.08238 0.578125 4.82689 0.845805 5.39575 1.38121C5.98133 1.93334 6.27413 2.65275 6.27413 3.53951C6.27413 4.3426 5.98971 5.01183 5.42085 5.54724C4.83527 6.09936 4.06564 6.37542 3.11197 6.37542H3.08687C2.16666 6.37542 1.42214 6.09936 0.853282 5.54724C0.284419 4.99511 0 4.30077 0 3.46422ZM0.326255 25.4237V8.6592H5.89768V25.4237H0.326255ZM8.98456 25.4237H14.556V16.0627C14.556 15.4771 14.6229 15.0253 14.7568 14.7075C14.991 14.1386 15.3465 13.6576 15.8234 13.2644C16.3002 12.8712 16.8983 12.6746 17.6178 12.6746C19.4916 12.6746 20.4286 13.9378 20.4286 16.4642V25.4237H26V15.8117C26 13.3355 25.4144 11.4575 24.2432 10.1775C23.0721 8.89762 21.5245 8.25766 19.6004 8.25766C17.4421 8.25766 15.7606 9.18623 14.556 11.0434V11.0936H14.5309L14.556 11.0434V8.6592H8.98456C9.01801 9.19459 9.03475 10.8593 9.03475 13.6534C9.03475 16.4475 9.01801 20.3709 8.98456 25.4237Z",
    fill: "#344157"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_10613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4442_10613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.444433c5.svg";
export { ForwardRef as ReactComponent };